import React, { useState, useEffect, useRef } from "react";
import Keyboard from "react-simple-keyboard";
import "react-simple-keyboard/build/css/index.css";
import styled from "styled-components";
import { useRecoilState } from "recoil";
import { langState } from "../recoil/lang";
import { japaneseLayout } from "./language/japaneseLayout";
import { chineseLayout } from "./language/chineseLayout";
import { spanishLayout } from "./language/spanishLayout";
import { englishLayout } from "./language/englishLayout";
import { thaiLayout } from "./language/thaiLayout";
import { frenchLayout } from "./language/frenchLayout";
import { russianLayout } from "./language/russianLayout";
import { germanLayout } from "./language/germanLayout";

interface KeyboardProps {
  showKeyboard: boolean;
  setShowKeyboard: React.Dispatch<React.SetStateAction<boolean>>;
  input: string;
  setInput: React.Dispatch<React.SetStateAction<string>>;
}

const ComponemtKeyboard: React.FC<KeyboardProps> = ({
  showKeyboard,
  setShowKeyboard,
  input,
  setInput,
}) => {
  const keyboard = useRef<any>(null);
  const textareaRef = useRef<HTMLTextAreaElement | null>(null);

  const [lang] = useRecoilState<number>(langState);
  const [candidates, setCandidates] = useState<string[]>([]);
  const [candidateKey, setCandidateKey] = useState<string>("");

  const layouts: { [key: string]: any } = {
    0: englishLayout,
    1: englishLayout,
    2: chineseLayout,
    3: japaneseLayout,
    4: thaiLayout,
    5: spanishLayout,
    6: frenchLayout,
    7: russianLayout,
    8: germanLayout,
  };

  const layout = layouts[String(lang)] || [];
  const layoutCandidates = layout.layoutCandidates || {};

  const onKeyPress = (button: string) => {
    if (button === "{shift}" || button === "{lock}") {
      handleShift();
      return;
    } else if (button === "{bksp}") {
      if (input.length > 0) {
        setInput(input.slice(0, -1));
      }
      return;
    }
    if (button === "{enter}") {
      setInput(input + "\n");
      return;
    }
    if (button === "{space}") {
      setInput(input + " ");
      return;
    }
    if (button === "{tab}") {
      setInput(input + "\t");
      return;
    }
    const regex = /[a-zA-Z]+$/;
    const match = (input + button).match(regex);

    if (match) {
      const candidateKey = match[0];
      if (layoutCandidates[candidateKey]) {
        console.log("candidateKey", candidateKey);
        const candidateList = layoutCandidates[candidateKey].split(" ");
        setCandidateKey(candidateKey);
        setCandidates(candidateList);
      } else {
        setCandidates([]);
      }
    } else {
      setCandidates([]);
    }
    setInput(input + button);
  };

  const onCandidateClick = (candidate: string) => {
    const lastIndex = input.lastIndexOf(candidateKey);
    let inputTemp = input;

    console.log("fixedInputTemp", inputTemp, candidateKey, lastIndex);

    if (lastIndex !== -1) {
      inputTemp =
        inputTemp.substring(0, lastIndex) +
        inputTemp.substring(lastIndex + candidateKey.length);
      console.log("update fixedInputTemp", inputTemp);
    }
    setInput(inputTemp + candidate);
    setCandidates([]);
  };

  const handleShift = () => {
    const currentLayout = keyboard.current.options.layoutName;
    const newLayout = currentLayout === "default" ? "shift" : "default";
    keyboard.current.setOptions({ layoutName: newLayout });
  };

  useEffect(() => {
    setInput("");
    setCandidates([]);
  }, [lang]);

  useEffect(() => {
    const textarea = textareaRef.current;

    if (textarea) {
      textarea.style.height = `${textarea.scrollHeight}px`;
    }
  }, [input]);

  useEffect(() => {
    if (showKeyboard && !input) {
    }
  }, [showKeyboard, input]);

  return (
    <>
      {showKeyboard && (
        <Style>
          <div className="wrap">
            <div className="totalKeyboardWrap">
              <div
                className="outWrap"
                onClick={() => setShowKeyboard(false)}
              ></div>
              <div className="keyboardWrap">
                {candidates.length > 0 && (
                  <div className="candidates">
                    {candidates.map((candidate, index) => (
                      <button
                        key={index}
                        onClick={() => onCandidateClick(candidate)}
                        className="candidateItem"
                      >
                        {candidate}
                      </button>
                    ))}
                  </div>
                )}
                <div className="textareaWrap">
                  <textarea ref={textareaRef} value={input} readOnly />
                </div>
                <Keyboard
                  keyboardRef={(r: any) => (keyboard.current = r)}
                  layoutName="default"
                  layout={layout}
                  onKeyPress={onKeyPress}
                />
              </div>
            </div>
          </div>
        </Style>
      )}
    </>
  );
};

export default ComponemtKeyboard;

const Style = styled.div`
  .candidates {
    display: flex;
    justify-content: start;
    background-color: #f0f0f0;
    border: 1px solid #ccc;
    border-radius: 4px;
    padding: 10px 20px;
    margin-top: 5px;
    padding-bottom: 15px;
    width: 100%;
    overflow-x: auto;
    overflow-y: hidden;
    white-space: nowrap;
    -webkit-overflow-scrolling: touch;
  }

  .candidateItem {
    margin-right: 10px;
    padding: 5px 7px;
    background-color: #fff;
    border: 1px solid #ddd;
    border-radius: 3px;
    width: 100%;
    white-space: nowrap;
  }

  .candidateItem:hover {
    background-color: #e0e0e0;
  }
  .wrap {
    width: 100vw;
    position: fixed;
    bottom: 0;
    z-index: 9999;
  }
  .totalKeyboardWrap {
    height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-end;
  }
  .outWrap {
    width: 100vw;
    flex: 2;
    background: #00000099;
  }
  .keyboardWrap {
    width: 100vw;
  }
  .simple-keyboard {
    background-color: #000 !important;
    color: #fff !important;
  }
  .hg-button:hover {
    background-color: #e0e0e0 !important;
  }
  .simple-keyboard .hg-button {
    color: #fff !important;
    background-color: #333;
  }
  .textareaWrap {
    border-top: 1px solid #737373;
    background: #000000;
    width: 100%;
    padding: 8px 20px;
  }
  textarea {
    margin-bottom: -5px;
    width: 100%;
    min-height: 60px;
    padding: 10px 20px;
    font-size: 16px;
    border: 1px solid #343434;
    box-sizing: border-box;
    background: #000;
    color: #fff;
    outline: none;
    overflow: hidden;
    white-space: pre-line;
  }

  .simple-keyboard {
    max-width: 850px;
  }
`;
